module.exports = __webpack_public_path__ + "img/artists-carrousel-4.c212d8ae.png";